module.exports = require("./zh-Hant.js");